import { FBModule } from '@/helpers/firebaseServices';
import { startLogRocket, stopLogRocketForInternalUser, identifyInLogRocket } from '@/utils/logRocket';
import store from '@/store';

export default {
  install: () => {
    // Subscribe to user Auth change (login/logout)
    FBModule.auth().onAuthStateChanged((user) => {
      // User is not signed-in
      if (!user) {
        startLogRocket();
        store.dispatch('user/auth/resetState');
        if (store.state.user.auth.isInitialLoading) store.dispatch('user/auth/updateIsInitialLoading', false);
        return;
      }

      // User is signed in
      if (!stopLogRocketForInternalUser(user.email)) {
        startLogRocket(user.email);
        identifyInLogRocket(user.uid, {
          name: user.displayName,
          email: user.email,
        });
      }
      store.dispatch('user/auth/updateAuthData', user).then(() => {
        if (store.state.user.auth.isInitialLoading) store.dispatch('user/auth/updateIsInitialLoading', false);
      });
    });
  },
};
